<template>
  <span
      v-if="resolvedTags.length"
      :class="['tag-pos-dots',{ 'for-calendar': forCalendar, [`mr-${marginRight}`]: marginRight }]">
    <span
      v-for="tag in resolvedTags"
      :key="tag.id"
      class="tag-pos-dot"
      :style="{ backgroundColor: tag.color }"
      :title="tag.label"
    />
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tagPosIds: {
    type: Array,
    required: false,
    default: () => []
  },
  tagPosCatalog: {
    type: Object,
    required: false,
    default: () => ({})
  },
  marginRight: {
    type: String,
    required: false
  },
  marginTop: {
    type: String,
    required: false
  },
  forCalendar: {
    type: Boolean,
    default: false,
    required: false
  }
});

const resolvedTags = computed(() => {
  if (!props.tagPosIds || !props.tagPosCatalog) return [];
  return props.tagPosIds
    .map(id => props.tagPosCatalog[id])
    .filter(tag => tag && tag.color);
});
</script>

<style scoped>
.tag-pos-dots {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  gap: 8px;
}

.tag-pos-dot {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.tag-pos-dots.for-calendar {
  position: absolute;
  right: 0.35em;
  top: 0.35em;
  gap: 0.3em;
}

.for-calendar .tag-pos-dot {
  width: 10px;
  height: 10px;
}
</style>

